module.exports = __webpack_public_path__ + "img/20180815_151629_187.335fd684.jpg";